import { format } from 'date-fns';
import { getLocale } from 'lib';

function formatLocale(date, text) {
  if (!date || !text) return '';

  return format(new Date(date), text, { locale: getLocale() });
}

export default formatLocale;
